import type { StepsProps } from 'antd';
import { Steps } from 'antd';
import type { IconRenderType } from 'antd/es/steps';
import classNames from 'classnames';
import React from 'react';

import { root, stepIcon } from './steps.ui';

const iconRender: IconRenderType = (_, { item }) => <span className={classNames('icon', stepIcon, item.status)} />;

const FBSteps: React.FC<StepsProps> = ({ classNames: callerClassNames, ...props }) => (
  <Steps iconRender={iconRender} {...props} classNames={{ root, ...callerClassNames }} />
);

export default FBSteps;
